"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.InputField = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = require("prop-types");

var _utils = require("@creditas/utils");

var _CheckCircle = _interopRequireDefault(require("@creditas/icons/dist/notification/CheckCircle"));

var _AlertTriangle = _interopRequireDefault(require("@creditas/icons/dist/alert/AlertTriangle"));

var _XCircle = _interopRequireDefault(require("@creditas/icons/dist/action/XCircle"));

var _Loader = _interopRequireDefault(require("@creditas/icons/dist/file/Loader"));

var _InputField = require("./components/InputField");

var _consts = require("./components/consts");

var _InputFieldComponent = require("./InputFieldComponent");

var _InputLabel = require("./InputLabel");

var _HelperText = require("./HelperText");

var _InputIcon = require("./InputIcon");

var _FormControl = require("./FormControl");

var _core = require("@emotion/core");

const propTypes = process.env.NODE_ENV !== "production" ? {
  component: (0, _propTypes.oneOfType)([_propTypes.elementType, _propTypes.string]),
  className: _propTypes.string,
  'data-testid': _propTypes.string,
  withRef: (0, _propTypes.oneOfType)([_propTypes.object, _propTypes.func]),
  defaultValue: _propTypes.string,
  disabled: _propTypes.bool,
  helperText: _propTypes.string,
  id: _propTypes.string,
  inputBackground: _propTypes.string || _propTypes.func,
  label: _propTypes.string,
  name: _propTypes.string,
  onBlur: _propTypes.func,
  onChange: _propTypes.func,
  onFocus: _propTypes.func,
  onInput: _propTypes.func,
  readOnly: _propTypes.bool,
  size: _propTypes.string,
  type: _propTypes.string,
  value: _propTypes.string,
  variant: _propTypes.string,
  width: _propTypes.string
} : {};

const IconSuccess = () => (0, _core.jsx)(_CheckCircle.default, {
  color: _consts.VARIANT_TYPES.success,
  fontSize: "small"
});

const IconWarning = () => (0, _core.jsx)(_XCircle.default, {
  color: _consts.VARIANT_TYPES.warning,
  fontSize: "small"
});

const IconError = () => (0, _core.jsx)(_AlertTriangle.default, {
  color: _consts.VARIANT_TYPES.danger,
  fontSize: "small"
});

const IconLoading = () => (0, _core.jsx)(_Loader.default, {
  color: "neutral05",
  fontSize: "small"
});

const variantIcon = {
  [_consts.VARIANT_TYPES.success]: IconSuccess,
  [_consts.VARIANT_TYPES.warning]: IconWarning,
  [_consts.VARIANT_TYPES.danger]: IconError,
  [_consts.VARIANT_TYPES.loading]: IconLoading
};

const InputField = ({
  component,
  className,
  'data-testid': dataTestId,
  withRef,
  defaultValue,
  disabled,
  helperText,
  id,
  inputBackground,
  label,
  name,
  onBlur,
  onChange,
  onFocus,
  onInput,
  readOnly,
  size = 'default',
  type = 'text',
  value,
  variant = 'default',
  width,
  ...other
}) => {
  const [labelShrink, setLabelShrink] = (0, _react.useState)(!!value || !!defaultValue);
  const [inputFocus, setInputFocus] = (0, _react.useState)(false);
  const [inputHover, setInputHover] = (0, _react.useState)(false);

  const hasValue = elementValue => {
    return elementValue && elementValue !== [] && elementValue !== '';
  };

  const toggleHover = () => setInputHover(!inputHover);

  const Icon = variantIcon[variant];
  return (0, _core.jsx)(_FormControl.FormControl, null, (0, _core.jsx)(_InputField.InputField, (0, _extends2.default)({
    as: component,
    className: className,
    label: label,
    width: width,
    size: size,
    disabled: disabled,
    inputFocus: inputFocus,
    inputHover: inputHover,
    readOnly: readOnly,
    inputBackground: inputBackground,
    variant: variant,
    onMouseEnter: toggleHover,
    onMouseLeave: toggleHover
  }, other), (0, _core.jsx)(_InputLabel.InputLabel, {
    labelShrink: labelShrink,
    size: size,
    inputFocus: inputFocus,
    inputHover: inputHover,
    disabled: disabled,
    readOnly: readOnly,
    inputBackground: inputBackground,
    variant: variant
  }, label), (0, _core.jsx)(_InputFieldComponent.InputFieldComponent, {
    ref: withRef,
    name: name,
    id: id,
    "data-testid": dataTestId,
    type: type,
    defaultValue: defaultValue,
    width: width,
    variant: variant,
    disabled: disabled,
    readOnly: readOnly,
    inputFocus: inputFocus,
    inputHover: inputHover,
    onFocus: event => {
      const content = event.target.value;

      if (readOnly && !content) {
        setLabelShrink(false);
        setInputFocus(false);
      } else {
        setLabelShrink(true);
        setInputFocus(true);
      }

      onFocus == null ? void 0 : onFocus(event);
    },
    onBlur: event => {
      const content = event.target.value;

      if (hasValue(content)) {
        setLabelShrink(true);
        setInputFocus(false);
      } else {
        setLabelShrink(false);
        setInputFocus(false);
      }

      onBlur == null ? void 0 : onBlur(event);
    },
    onChange: event => {
      onChange == null ? void 0 : onChange(event);
    },
    onInput: event => {
      onInput == null ? void 0 : onInput(event);
    },
    value: value
  }), !(() => variant === 'default' || disabled || readOnly)() && (0, _core.jsx)(_InputIcon.InputIcon, {
    variant: variant,
    relatedInputType: "input",
    inputFocus: inputFocus,
    readOnly: readOnly
  }, (0, _core.jsx)(Icon, null))), helperText && (0, _core.jsx)(_HelperText.HelperText, {
    text: helperText,
    variant: variant,
    size: size,
    disabled: disabled,
    width: width
  }));
};

process.env.NODE_ENV !== "production" ? InputField.propTypes = propTypes : void 0;
const WithForwardRef = (0, _utils.withForwardRef)(InputField);
exports.InputField = WithForwardRef;